export default "__VITE_ASSET__2cd956bc__"